import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import ModelFormik from './ModelFormik'
import SettingModelForm from './SettingModelFormik'
import { IVehicleMake, IMap } from 'src/types'
import Select from 'react-select'

interface IAddModelModalProps extends RouteComponentProps {
  createVehicleModel: (name: string, makeId: string) => Promise<any>
  makes: IVehicleMake[]
}

export default class AddModelModal extends React.Component<IAddModelModalProps> {
  public render() {
    const makes: Array<{ label: string; value: string }> = []
    for (const i of Object.keys(this.props.makes)) {
      const make = this.props.makes[i]
      makes.push({
        value: make.id,
        label: make.name
      })
    }
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <SettingModelForm
              makeList={this.props.makes}
              onSubmit={this.onAdd}
              title='ADD VEHICLE MODEL'
              labelTitle='Model'
            >
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </SettingModelForm>
          </div>
        </div>
      </Modal>
    )
  }

  private onAdd = (label: string, make: string) => {
    return new Promise<void>(approve => {
      approve()
      this.props.createVehicleModel(label, make).then(() => {
        approve()
        setTimeout(() => {
          this.onCancel()
        }, 1000)
      })
    })
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/model')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AddModelModal.tsx